export default __webpack_public_path__ + "static/media/gift-03.2232546c.svg";